'use strict';
var parent = require('../../actual/instance/fill');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/full/instance/fill.js
// module id = 619
// module chunks = 13